// ============================================================================
// Section Typography Context — provides section-level typography inheritance
// Text/heading blocks without their own typography settings inherit from here.
// ============================================================================

import { createContext, useContext } from 'react';
import type { TypographyConfig } from '../editor/types';

const SectionTypographyContext = createContext<TypographyConfig | undefined>(undefined);

export const SectionTypographyProvider = SectionTypographyContext.Provider;

/**
 * Returns the effective typography config for a block.
 * Block-level typography takes precedence; section-level is the fallback.
 */
export function useEffectiveTypography(
  blockTypography?: TypographyConfig,
): TypographyConfig | undefined {
  const sectionTypography = useContext(SectionTypographyContext);
  if (!blockTypography && !sectionTypography) return undefined;
  // Merge: block overrides section
  return {
    ...sectionTypography,
    ...blockTypography,
  };
}
